import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";

import { AppProvider } from "@/context/AppContext";
import Layout from "@/components/Layout";

import Home from "@/pages/Home";
import Shop from "@/pages/Shop";
import CollectionPage from "@/pages/CollectionPage";
import ProductDetail from "@/pages/ProductDetail";
import Cart from "@/pages/Cart";
import OrderSuccess from "@/pages/OrderSuccess";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import Account from "@/pages/Account";
import Wishlist from "@/pages/Wishlist";
import AuthCallback from "@/pages/AuthCallback";
import { Blog, BlogPost } from "@/pages/Blog";

import AdminLayout from "@/pages/admin/AdminLayout";
import AdminLogin from "@/pages/admin/AdminLogin";
import AdminDashboard from "@/pages/admin/AdminDashboard";
import AdminProducts from "@/pages/admin/AdminProducts";
import AdminHomepage from "@/pages/admin/AdminHomepage";
import AdminOrders from "@/pages/admin/AdminOrders";
import AdminReviews from "@/pages/admin/AdminReviews";
import AdminDiscounts from "@/pages/admin/AdminDiscounts";
import AdminCustomers from "@/pages/admin/AdminCustomers";
import AdminBlog from "@/pages/admin/AdminBlog";
import AdminCollections from "@/pages/admin/AdminCollections";

function AppRouter() {
    const location = useLocation();
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    if (location.hash?.includes("session_id=")) {
        return <AuthCallback />;
    }
    return (
        <Routes>
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route path="/admin" element={<AdminLayout />}>
                <Route index element={<AdminDashboard />} />
                <Route path="products" element={<AdminProducts />} />
                <Route path="homepage" element={<AdminHomepage />} />
                <Route path="orders" element={<AdminOrders />} />
                <Route path="reviews" element={<AdminReviews />} />
                <Route path="discounts" element={<AdminDiscounts />} />
                <Route path="customers" element={<AdminCustomers />} />
                <Route path="blog" element={<AdminBlog />} />
                <Route path="collections" element={<AdminCollections />} />
            </Route>

            <Route
                path="*"
                element={
                    <Layout>
                        <Routes>
                            <Route path="/" element={<Home />} />
                            <Route path="/shop" element={<Shop />} />
                            <Route path="/collection/:slug" element={<CollectionPage />} />
                            <Route path="/product/:slug" element={<ProductDetail />} />
                            <Route path="/cart" element={<Cart />} />
                            <Route path="/order/success" element={<OrderSuccess />} />
                            <Route path="/login" element={<Login />} />
                            <Route path="/register" element={<Register />} />
                            <Route path="/account" element={<Account />} />
                            <Route path="/wishlist" element={<Wishlist />} />
                            <Route path="/blog" element={<Blog />} />
                            <Route path="/blog/:slug" element={<BlogPost />} />
                            <Route path="*" element={<NotFound />} />
                        </Routes>
                    </Layout>
                }
            />
        </Routes>
    );
}

const NotFound = () => (
    <div className="px-6 py-32 text-center" data-testid="not-found">
        <div className="overline mb-3">404</div>
        <h1 className="font-display text-5xl text-[color:var(--ms-charcoal)]">Pagina non trovata</h1>
        <a href="/" className="overline mt-6 inline-block link-underline">TORNA ALLA HOME</a>
    </div>
);

export default function App() {
    return (
        <div className="App">
            <BrowserRouter>
                <AppProvider>
                    <AppRouter />
                    <Toaster theme="light" position="top-center" toastOptions={{ style: { background: "#FEFCF8", border: "1px solid #E4D8C5", color: "#2E2823" } }} />
                </AppProvider>
            </BrowserRouter>
        </div>
    );
}
